<template>
  <div id="knowledge-card">
    <v-layout align-center row wrap>
      <v-flex pb-0 xs12>
        <v-autocomplete
          class="search-box"
          clearable
          :items="topics"
          item-text="name"
          item-value="idx"
          label="ค้นหาตามชนิดบทเรียน"
          solo
          v-model="selectedTopic"
        ></v-autocomplete>
      </v-flex>
      <v-flex :key="knowledge.idx" md4 pt-0 sm6 v-for="knowledge in filterKnowledges" xs12>
        <v-card
          class="mouse-pointer"
          @click="onClickList(knowledge.idx, knowledge.title)"
          color="transparent"
          elevation="0"
        >
          <v-img
            :aspect-ratio="16 / 9"
            cover
            :lazy-src="require('@/assets/NoPicture.png')"
            :src="
              knowledge.pictureCover ? knowledge.pictureCover : require('@/assets/NoPicture.png')
            "
          >
            <template v-slot:placeholder>
              <v-layout align-center fill-height justify-center ma-0>
                <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
          <v-card-title>
            <div>
              <!-- <span class="caption purple--text text--darken-2">{{ $moment(knowledge.post_date).format("MMMM Do, YYYY") }}</span> -->
              <div class="title mb-2">{{ knowledge.title }}</div>
              <div class="body-1 primary--text">{{ `หัวข้อ : ${knowledge.topicName}` }}</div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      selectedTopic: ''
    }
  },
  computed: {
    filterKnowledges() {
      return this.$store.getters['Knowledge/getAll'].filter(item =>
        item.topicId.match(this.selectedTopic)
      )
    },
    knowledges() {
      return this.$store.getters['Knowledge/getAll']
    },
    topics() {
      return this.$store.getters['Topic/getAll']
    }
  },
  created() {
    this.$store.dispatch('Knowledge/fetch')
    this.$store.dispatch('Topic/fetch')
  },
  methods: {
    onClickList(knowledgeId) {
      // this.$router.push({
      // name: 'knowledge-detail',
      // params: {
      // knowledgeId: window.btoa(knowledgeId)
      // }
      // })
      window.location = `https://school.farmerspace.co/${knowledgeId}`
    }
  }
}
</script>

<style lang="scss" scoped></style>
